/**
 * /**
 *  * Auto-generated by Orval
 *  * OpenAPI spec: Auto-Playlist V2 API v1.0.0
 *  * DO NOT EDIT MANUALLY
 *  *\/
 *
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  CostAlert,
  CostAlertListParams,
  CostAlertRequest,
  CostLimit,
  CostLimitListParams,
  CostLimitRequest,
  PaginatedCostAlertList,
  PaginatedCostLimitList,
  PatchedCostLimitRequest,
} from "../../models";

import { customInstance } from "../../custom-instance";
import type { ErrorType, BodyType } from "../../custom-instance";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * ViewSet for viewing cost alerts.

Endpoints:
    GET /api/cost-alerts/ - List all alerts
    GET /api/cost-alerts/{id}/ - Get specific alert
    GET /api/cost-alerts/unacknowledged/list/ - Get unacknowledged alerts
    POST /api/cost-alerts/{id}/acknowledge/ - Mark alert as acknowledged
 * @summary 비용 알림 목록 조회
 */
export const costAlertList = (
  params?: CostAlertListParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<PaginatedCostAlertList>(
    { url: `/api/cost-alerts/`, method: "GET", params, signal },
    options,
  );
};

export const getCostAlertListQueryKey = (params?: CostAlertListParams) => {
  return [`/api/cost-alerts/`, ...(params ? [params] : [])] as const;
};

export const getCostAlertListQueryOptions = <
  TData = Awaited<ReturnType<typeof costAlertList>>,
  TError = ErrorType<unknown>,
>(
  params?: CostAlertListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof costAlertList>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getCostAlertListQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof costAlertList>>> = ({
    signal,
  }) => costAlertList(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof costAlertList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type CostAlertListQueryResult = NonNullable<
  Awaited<ReturnType<typeof costAlertList>>
>;
export type CostAlertListQueryError = ErrorType<unknown>;

export function useCostAlertList<
  TData = Awaited<ReturnType<typeof costAlertList>>,
  TError = ErrorType<unknown>,
>(
  params: undefined | CostAlertListParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof costAlertList>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof costAlertList>>,
          TError,
          Awaited<ReturnType<typeof costAlertList>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useCostAlertList<
  TData = Awaited<ReturnType<typeof costAlertList>>,
  TError = ErrorType<unknown>,
>(
  params?: CostAlertListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof costAlertList>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof costAlertList>>,
          TError,
          Awaited<ReturnType<typeof costAlertList>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useCostAlertList<
  TData = Awaited<ReturnType<typeof costAlertList>>,
  TError = ErrorType<unknown>,
>(
  params?: CostAlertListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof costAlertList>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 비용 알림 목록 조회
 */

export function useCostAlertList<
  TData = Awaited<ReturnType<typeof costAlertList>>,
  TError = ErrorType<unknown>,
>(
  params?: CostAlertListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof costAlertList>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getCostAlertListQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * ViewSet for viewing cost alerts.

Endpoints:
    GET /api/cost-alerts/ - List all alerts
    GET /api/cost-alerts/{id}/ - Get specific alert
    GET /api/cost-alerts/unacknowledged/list/ - Get unacknowledged alerts
    POST /api/cost-alerts/{id}/acknowledge/ - Mark alert as acknowledged
 * @summary 비용 알림 상세 조회
 */
export const costAlertRetrieve = (
  id: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<CostAlert>(
    { url: `/api/cost-alerts/${id}/`, method: "GET", signal },
    options,
  );
};

export const getCostAlertRetrieveQueryKey = (id?: string) => {
  return [`/api/cost-alerts/${id}/`] as const;
};

export const getCostAlertRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof costAlertRetrieve>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof costAlertRetrieve>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getCostAlertRetrieveQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof costAlertRetrieve>>
  > = ({ signal }) => costAlertRetrieve(id, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof costAlertRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type CostAlertRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof costAlertRetrieve>>
>;
export type CostAlertRetrieveQueryError = ErrorType<unknown>;

export function useCostAlertRetrieve<
  TData = Awaited<ReturnType<typeof costAlertRetrieve>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof costAlertRetrieve>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof costAlertRetrieve>>,
          TError,
          Awaited<ReturnType<typeof costAlertRetrieve>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useCostAlertRetrieve<
  TData = Awaited<ReturnType<typeof costAlertRetrieve>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof costAlertRetrieve>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof costAlertRetrieve>>,
          TError,
          Awaited<ReturnType<typeof costAlertRetrieve>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useCostAlertRetrieve<
  TData = Awaited<ReturnType<typeof costAlertRetrieve>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof costAlertRetrieve>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 비용 알림 상세 조회
 */

export function useCostAlertRetrieve<
  TData = Awaited<ReturnType<typeof costAlertRetrieve>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof costAlertRetrieve>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getCostAlertRetrieveQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Mark alert as acknowledged.
 * @summary 비용 알림 확인 처리
 */
export const costAlertAcknowledge = (
  id: string,
  costAlertRequest: BodyType<CostAlertRequest>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<CostAlert>(
    {
      url: `/api/cost-alerts/${id}/acknowledge/`,
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      data: costAlertRequest,
      signal,
    },
    options,
  );
};

export const getCostAlertAcknowledgeMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof costAlertAcknowledge>>,
    TError,
    { id: string; data: BodyType<CostAlertRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof costAlertAcknowledge>>,
  TError,
  { id: string; data: BodyType<CostAlertRequest> },
  TContext
> => {
  const mutationKey = ["costAlertAcknowledge"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof costAlertAcknowledge>>,
    { id: string; data: BodyType<CostAlertRequest> }
  > = (props) => {
    const { id, data } = props ?? {};

    return costAlertAcknowledge(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CostAlertAcknowledgeMutationResult = NonNullable<
  Awaited<ReturnType<typeof costAlertAcknowledge>>
>;
export type CostAlertAcknowledgeMutationBody = BodyType<CostAlertRequest>;
export type CostAlertAcknowledgeMutationError = ErrorType<unknown>;

/**
 * @summary 비용 알림 확인 처리
 */
export const useCostAlertAcknowledge = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof costAlertAcknowledge>>,
      TError,
      { id: string; data: BodyType<CostAlertRequest> },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof costAlertAcknowledge>>,
  TError,
  { id: string; data: BodyType<CostAlertRequest> },
  TContext
> => {
  const mutationOptions = getCostAlertAcknowledgeMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Get all unacknowledged alerts for user.
 * @summary 미확인 비용 알림 목록
 */
export const costAlertUnacknowledged = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<CostAlert>(
    { url: `/api/cost-alerts/unacknowledged/`, method: "GET", signal },
    options,
  );
};

export const getCostAlertUnacknowledgedQueryKey = () => {
  return [`/api/cost-alerts/unacknowledged/`] as const;
};

export const getCostAlertUnacknowledgedQueryOptions = <
  TData = Awaited<ReturnType<typeof costAlertUnacknowledged>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof costAlertUnacknowledged>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getCostAlertUnacknowledgedQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof costAlertUnacknowledged>>
  > = ({ signal }) => costAlertUnacknowledged(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof costAlertUnacknowledged>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type CostAlertUnacknowledgedQueryResult = NonNullable<
  Awaited<ReturnType<typeof costAlertUnacknowledged>>
>;
export type CostAlertUnacknowledgedQueryError = ErrorType<unknown>;

export function useCostAlertUnacknowledged<
  TData = Awaited<ReturnType<typeof costAlertUnacknowledged>>,
  TError = ErrorType<unknown>,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof costAlertUnacknowledged>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof costAlertUnacknowledged>>,
          TError,
          Awaited<ReturnType<typeof costAlertUnacknowledged>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useCostAlertUnacknowledged<
  TData = Awaited<ReturnType<typeof costAlertUnacknowledged>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof costAlertUnacknowledged>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof costAlertUnacknowledged>>,
          TError,
          Awaited<ReturnType<typeof costAlertUnacknowledged>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useCostAlertUnacknowledged<
  TData = Awaited<ReturnType<typeof costAlertUnacknowledged>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof costAlertUnacknowledged>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 미확인 비용 알림 목록
 */

export function useCostAlertUnacknowledged<
  TData = Awaited<ReturnType<typeof costAlertUnacknowledged>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof costAlertUnacknowledged>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getCostAlertUnacknowledgedQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * ViewSet for managing cost limits per service.

Endpoints:
    GET /api/cost-limits/ - List all cost limits
    POST /api/cost-limits/ - Create new cost limit
    GET /api/cost-limits/{id}/ - Get specific cost limit
    PUT /api/cost-limits/{id}/ - Update cost limit
    PATCH /api/cost-limits/{id}/ - Partial update
    DELETE /api/cost-limits/{id}/ - Delete cost limit
    GET /api/cost-limits/check/status/ - Check all limits against current spending
    POST /api/cost-limits/{id}/reset/ - Reset monthly spending for limit
 * @summary 비용 한도 목록 조회
 */
export const costLimitList = (
  params?: CostLimitListParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<PaginatedCostLimitList>(
    { url: `/api/cost-limits/`, method: "GET", params, signal },
    options,
  );
};

export const getCostLimitListQueryKey = (params?: CostLimitListParams) => {
  return [`/api/cost-limits/`, ...(params ? [params] : [])] as const;
};

export const getCostLimitListQueryOptions = <
  TData = Awaited<ReturnType<typeof costLimitList>>,
  TError = ErrorType<unknown>,
>(
  params?: CostLimitListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof costLimitList>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getCostLimitListQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof costLimitList>>> = ({
    signal,
  }) => costLimitList(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof costLimitList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type CostLimitListQueryResult = NonNullable<
  Awaited<ReturnType<typeof costLimitList>>
>;
export type CostLimitListQueryError = ErrorType<unknown>;

export function useCostLimitList<
  TData = Awaited<ReturnType<typeof costLimitList>>,
  TError = ErrorType<unknown>,
>(
  params: undefined | CostLimitListParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof costLimitList>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof costLimitList>>,
          TError,
          Awaited<ReturnType<typeof costLimitList>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useCostLimitList<
  TData = Awaited<ReturnType<typeof costLimitList>>,
  TError = ErrorType<unknown>,
>(
  params?: CostLimitListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof costLimitList>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof costLimitList>>,
          TError,
          Awaited<ReturnType<typeof costLimitList>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useCostLimitList<
  TData = Awaited<ReturnType<typeof costLimitList>>,
  TError = ErrorType<unknown>,
>(
  params?: CostLimitListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof costLimitList>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 비용 한도 목록 조회
 */

export function useCostLimitList<
  TData = Awaited<ReturnType<typeof costLimitList>>,
  TError = ErrorType<unknown>,
>(
  params?: CostLimitListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof costLimitList>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getCostLimitListQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * ViewSet for managing cost limits per service.

Endpoints:
    GET /api/cost-limits/ - List all cost limits
    POST /api/cost-limits/ - Create new cost limit
    GET /api/cost-limits/{id}/ - Get specific cost limit
    PUT /api/cost-limits/{id}/ - Update cost limit
    PATCH /api/cost-limits/{id}/ - Partial update
    DELETE /api/cost-limits/{id}/ - Delete cost limit
    GET /api/cost-limits/check/status/ - Check all limits against current spending
    POST /api/cost-limits/{id}/reset/ - Reset monthly spending for limit
 * @summary 비용 한도 생성
 */
export const costLimitCreate = (
  costLimitRequest: BodyType<CostLimitRequest>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<CostLimit>(
    {
      url: `/api/cost-limits/`,
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      data: costLimitRequest,
      signal,
    },
    options,
  );
};

export const getCostLimitCreateMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof costLimitCreate>>,
    TError,
    { data: BodyType<CostLimitRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof costLimitCreate>>,
  TError,
  { data: BodyType<CostLimitRequest> },
  TContext
> => {
  const mutationKey = ["costLimitCreate"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof costLimitCreate>>,
    { data: BodyType<CostLimitRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return costLimitCreate(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CostLimitCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof costLimitCreate>>
>;
export type CostLimitCreateMutationBody = BodyType<CostLimitRequest>;
export type CostLimitCreateMutationError = ErrorType<unknown>;

/**
 * @summary 비용 한도 생성
 */
export const useCostLimitCreate = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof costLimitCreate>>,
      TError,
      { data: BodyType<CostLimitRequest> },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof costLimitCreate>>,
  TError,
  { data: BodyType<CostLimitRequest> },
  TContext
> => {
  const mutationOptions = getCostLimitCreateMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * ViewSet for managing cost limits per service.

Endpoints:
    GET /api/cost-limits/ - List all cost limits
    POST /api/cost-limits/ - Create new cost limit
    GET /api/cost-limits/{id}/ - Get specific cost limit
    PUT /api/cost-limits/{id}/ - Update cost limit
    PATCH /api/cost-limits/{id}/ - Partial update
    DELETE /api/cost-limits/{id}/ - Delete cost limit
    GET /api/cost-limits/check/status/ - Check all limits against current spending
    POST /api/cost-limits/{id}/reset/ - Reset monthly spending for limit
 * @summary 비용 한도 상세 조회
 */
export const costLimitRetrieve = (
  id: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<CostLimit>(
    { url: `/api/cost-limits/${id}/`, method: "GET", signal },
    options,
  );
};

export const getCostLimitRetrieveQueryKey = (id?: string) => {
  return [`/api/cost-limits/${id}/`] as const;
};

export const getCostLimitRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof costLimitRetrieve>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof costLimitRetrieve>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getCostLimitRetrieveQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof costLimitRetrieve>>
  > = ({ signal }) => costLimitRetrieve(id, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof costLimitRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type CostLimitRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof costLimitRetrieve>>
>;
export type CostLimitRetrieveQueryError = ErrorType<unknown>;

export function useCostLimitRetrieve<
  TData = Awaited<ReturnType<typeof costLimitRetrieve>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof costLimitRetrieve>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof costLimitRetrieve>>,
          TError,
          Awaited<ReturnType<typeof costLimitRetrieve>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useCostLimitRetrieve<
  TData = Awaited<ReturnType<typeof costLimitRetrieve>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof costLimitRetrieve>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof costLimitRetrieve>>,
          TError,
          Awaited<ReturnType<typeof costLimitRetrieve>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useCostLimitRetrieve<
  TData = Awaited<ReturnType<typeof costLimitRetrieve>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof costLimitRetrieve>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 비용 한도 상세 조회
 */

export function useCostLimitRetrieve<
  TData = Awaited<ReturnType<typeof costLimitRetrieve>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof costLimitRetrieve>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getCostLimitRetrieveQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * ViewSet for managing cost limits per service.

Endpoints:
    GET /api/cost-limits/ - List all cost limits
    POST /api/cost-limits/ - Create new cost limit
    GET /api/cost-limits/{id}/ - Get specific cost limit
    PUT /api/cost-limits/{id}/ - Update cost limit
    PATCH /api/cost-limits/{id}/ - Partial update
    DELETE /api/cost-limits/{id}/ - Delete cost limit
    GET /api/cost-limits/check/status/ - Check all limits against current spending
    POST /api/cost-limits/{id}/reset/ - Reset monthly spending for limit
 * @summary 비용 한도 수정
 */
export const costLimitUpdate = (
  id: string,
  costLimitRequest: BodyType<CostLimitRequest>,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<CostLimit>(
    {
      url: `/api/cost-limits/${id}/`,
      method: "PUT",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      data: costLimitRequest,
    },
    options,
  );
};

export const getCostLimitUpdateMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof costLimitUpdate>>,
    TError,
    { id: string; data: BodyType<CostLimitRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof costLimitUpdate>>,
  TError,
  { id: string; data: BodyType<CostLimitRequest> },
  TContext
> => {
  const mutationKey = ["costLimitUpdate"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof costLimitUpdate>>,
    { id: string; data: BodyType<CostLimitRequest> }
  > = (props) => {
    const { id, data } = props ?? {};

    return costLimitUpdate(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CostLimitUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof costLimitUpdate>>
>;
export type CostLimitUpdateMutationBody = BodyType<CostLimitRequest>;
export type CostLimitUpdateMutationError = ErrorType<unknown>;

/**
 * @summary 비용 한도 수정
 */
export const useCostLimitUpdate = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof costLimitUpdate>>,
      TError,
      { id: string; data: BodyType<CostLimitRequest> },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof costLimitUpdate>>,
  TError,
  { id: string; data: BodyType<CostLimitRequest> },
  TContext
> => {
  const mutationOptions = getCostLimitUpdateMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * ViewSet for managing cost limits per service.

Endpoints:
    GET /api/cost-limits/ - List all cost limits
    POST /api/cost-limits/ - Create new cost limit
    GET /api/cost-limits/{id}/ - Get specific cost limit
    PUT /api/cost-limits/{id}/ - Update cost limit
    PATCH /api/cost-limits/{id}/ - Partial update
    DELETE /api/cost-limits/{id}/ - Delete cost limit
    GET /api/cost-limits/check/status/ - Check all limits against current spending
    POST /api/cost-limits/{id}/reset/ - Reset monthly spending for limit
 * @summary 비용 한도 부분 수정
 */
export const costLimitPartialUpdate = (
  id: string,
  patchedCostLimitRequest: BodyType<PatchedCostLimitRequest>,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<CostLimit>(
    {
      url: `/api/cost-limits/${id}/`,
      method: "PATCH",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      data: patchedCostLimitRequest,
    },
    options,
  );
};

export const getCostLimitPartialUpdateMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof costLimitPartialUpdate>>,
    TError,
    { id: string; data: BodyType<PatchedCostLimitRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof costLimitPartialUpdate>>,
  TError,
  { id: string; data: BodyType<PatchedCostLimitRequest> },
  TContext
> => {
  const mutationKey = ["costLimitPartialUpdate"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof costLimitPartialUpdate>>,
    { id: string; data: BodyType<PatchedCostLimitRequest> }
  > = (props) => {
    const { id, data } = props ?? {};

    return costLimitPartialUpdate(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CostLimitPartialUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof costLimitPartialUpdate>>
>;
export type CostLimitPartialUpdateMutationBody =
  BodyType<PatchedCostLimitRequest>;
export type CostLimitPartialUpdateMutationError = ErrorType<unknown>;

/**
 * @summary 비용 한도 부분 수정
 */
export const useCostLimitPartialUpdate = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof costLimitPartialUpdate>>,
      TError,
      { id: string; data: BodyType<PatchedCostLimitRequest> },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof costLimitPartialUpdate>>,
  TError,
  { id: string; data: BodyType<PatchedCostLimitRequest> },
  TContext
> => {
  const mutationOptions = getCostLimitPartialUpdateMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * ViewSet for managing cost limits per service.

Endpoints:
    GET /api/cost-limits/ - List all cost limits
    POST /api/cost-limits/ - Create new cost limit
    GET /api/cost-limits/{id}/ - Get specific cost limit
    PUT /api/cost-limits/{id}/ - Update cost limit
    PATCH /api/cost-limits/{id}/ - Partial update
    DELETE /api/cost-limits/{id}/ - Delete cost limit
    GET /api/cost-limits/check/status/ - Check all limits against current spending
    POST /api/cost-limits/{id}/reset/ - Reset monthly spending for limit
 * @summary 비용 한도 삭제
 */
export const costLimitDestroy = (
  id: string,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<void>(
    { url: `/api/cost-limits/${id}/`, method: "DELETE" },
    options,
  );
};

export const getCostLimitDestroyMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof costLimitDestroy>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof costLimitDestroy>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["costLimitDestroy"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof costLimitDestroy>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return costLimitDestroy(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CostLimitDestroyMutationResult = NonNullable<
  Awaited<ReturnType<typeof costLimitDestroy>>
>;

export type CostLimitDestroyMutationError = ErrorType<unknown>;

/**
 * @summary 비용 한도 삭제
 */
export const useCostLimitDestroy = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof costLimitDestroy>>,
      TError,
      { id: string },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof costLimitDestroy>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getCostLimitDestroyMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Reset monthly spending for a cost limit.
 * @summary 비용 한도 초기화
 */
export const costLimitReset = (
  id: string,
  costLimitRequest: BodyType<CostLimitRequest>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<CostLimit>(
    {
      url: `/api/cost-limits/${id}/reset/`,
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      data: costLimitRequest,
      signal,
    },
    options,
  );
};

export const getCostLimitResetMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof costLimitReset>>,
    TError,
    { id: string; data: BodyType<CostLimitRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof costLimitReset>>,
  TError,
  { id: string; data: BodyType<CostLimitRequest> },
  TContext
> => {
  const mutationKey = ["costLimitReset"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof costLimitReset>>,
    { id: string; data: BodyType<CostLimitRequest> }
  > = (props) => {
    const { id, data } = props ?? {};

    return costLimitReset(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CostLimitResetMutationResult = NonNullable<
  Awaited<ReturnType<typeof costLimitReset>>
>;
export type CostLimitResetMutationBody = BodyType<CostLimitRequest>;
export type CostLimitResetMutationError = ErrorType<unknown>;

/**
 * @summary 비용 한도 초기화
 */
export const useCostLimitReset = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof costLimitReset>>,
      TError,
      { id: string; data: BodyType<CostLimitRequest> },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof costLimitReset>>,
  TError,
  { id: string; data: BodyType<CostLimitRequest> },
  TContext
> => {
  const mutationOptions = getCostLimitResetMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Check all cost limits against current spending.

Returns warnings and exceeded limits.
 * @summary 비용 한도 상태 확인
 */
export const costLimitCheckStatus = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<CostLimit>(
    { url: `/api/cost-limits/check_status/`, method: "GET", signal },
    options,
  );
};

export const getCostLimitCheckStatusQueryKey = () => {
  return [`/api/cost-limits/check_status/`] as const;
};

export const getCostLimitCheckStatusQueryOptions = <
  TData = Awaited<ReturnType<typeof costLimitCheckStatus>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof costLimitCheckStatus>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getCostLimitCheckStatusQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof costLimitCheckStatus>>
  > = ({ signal }) => costLimitCheckStatus(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof costLimitCheckStatus>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type CostLimitCheckStatusQueryResult = NonNullable<
  Awaited<ReturnType<typeof costLimitCheckStatus>>
>;
export type CostLimitCheckStatusQueryError = ErrorType<unknown>;

export function useCostLimitCheckStatus<
  TData = Awaited<ReturnType<typeof costLimitCheckStatus>>,
  TError = ErrorType<unknown>,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof costLimitCheckStatus>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof costLimitCheckStatus>>,
          TError,
          Awaited<ReturnType<typeof costLimitCheckStatus>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useCostLimitCheckStatus<
  TData = Awaited<ReturnType<typeof costLimitCheckStatus>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof costLimitCheckStatus>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof costLimitCheckStatus>>,
          TError,
          Awaited<ReturnType<typeof costLimitCheckStatus>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useCostLimitCheckStatus<
  TData = Awaited<ReturnType<typeof costLimitCheckStatus>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof costLimitCheckStatus>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 비용 한도 상태 확인
 */

export function useCostLimitCheckStatus<
  TData = Awaited<ReturnType<typeof costLimitCheckStatus>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof costLimitCheckStatus>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getCostLimitCheckStatusQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}
